import React, { useEffect } from "react";
import InputField from "./InputField";
// import axios from "axios";
// import UserService from "rc-app/services/UserService";
import { CardBorder } from "../CardBorder";
import CustomSelect from "./CustomSelect";

interface OperationalTaxProps {
  formData: any;
  onInputChange: (e: any) => void;
  onBlur: (fieldName: string) => void;
  errors: any;
  touched: Set<string>;
  [key: string]: any;
}

const OperationalTax: React.FC<OperationalTaxProps> = ({
  formData,
  onInputChange,
  onBlur,
  errors,
  touched,
}) => {
  //   const [isEditing, setIsEditing] = useState(false);
  //   console.log("isEditing", isEditing);
  //   const fileInputRef = useRef(null);

  const handleLocalBlur = (e: any) => {
    const { name } = e.target;
    onBlur(name);
  };

  const shouldShowError = (fieldName: string) => {
    return touched.has(fieldName) && errors[fieldName];
  };
useEffect(()=>{
  console.log("incorporation_year", formData);
  console.log("incorporation_year_1",shouldShowError("tax_paid_to_date.value"));
  
  
},[formData])
  return (
    <div className="flex flex-col bg-[#1C2C3A]">
      <CardBorder title="Operations" borderColor="border-[#2E4051]">
        <div className="flex w-full gap-4 items-center justify-center">
          <div className="flex w-full flex-wrap">
            <div className="flex w-full md:w-1/2 px-3 mb-6">
              <InputField
                label="Client Incorporation Year"
                name="incorporation_year"
                value={formData.incorporation_year}
                onChange={onInputChange}
                onBlur={handleLocalBlur}
                placeholder="Enter..."
                error={
                  shouldShowError("incorporation_year")
                    ? errors.incorporation_year
                    : undefined
                }
              />
            </div>

            {/* <div className="flex w-full md:w-1/2 px-3 mb-6">
              <InputField
                label="Client Incorporation Type"
                name="incorporation_type"
                value={formData.incorporation_type}
                onChange={onInputChange}
                onBlur={handleLocalBlur}
                placeholder="Enter..."
                error={
                  shouldShowError("incorporation_type")
                    ? errors.incorporation_type
                    : undefined
                }
              />
            </div> */}

            <div className="flex w-full md:w-1/2 px-3 mb-6">
              <CustomSelect
                label="Client Incorporation Type"
                name="incorporation_type"
                value={formData.incorporation_type}
                onChange={onInputChange}
                onBlur={handleLocalBlur}
                placeholder="Enter..."
                error={
                  shouldShowError("incorporation_type")
                    ? errors.incorporation_type
                    : undefined
                }
                
                options={[
                  { value: "Propreitary", label: "Propreitary" },
                  { value: "Partnership", label: "Partnership" },
                  { value: "LLP", label: "LLP" },
                  { value: "Private Limited Label ", label: "Private Limited Label " },
                  { value: "Others", label: "Others" },
                  { value: "International", label: "International" },
                ]}
              />
            </div>

            <div className="flex w-full md:w-1/2 px-3 mb-6">
              <InputField
                label="Client Subsdiary Names"
                name="agency_subsidiary_names"
                value={formData.agency_subsidiary_names}
                onChange={onInputChange}
                onBlur={handleLocalBlur}
                placeholder="Enter..."
                error={
                  shouldShowError("agency_subsidiary_names")
                    ? errors.agency_subsidiary_names
                    : undefined
                }
              />
            </div>

            <div className="flex w-full md:w-1/2 px-3 mb-6">
              <InputField
                label="Client Acreage Completed"
                name="client_acreage_acquired.value"
                value={formData.client_acreage_acquired.value}
                onChange={onInputChange}
                onBlur={handleLocalBlur}
                placeholder="Enter..."
                error={
                  shouldShowError("client_acreage_acquired.value")
                    ? errors['client_acreage_acquired.value']
                    : undefined
                }
              />
            </div>

            <div className="flex w-full md:w-1/2 px-3 mb-6">
              <InputField
                label="Client Sqft Built"
                name="client_sqft_built.value"
                value={formData.client_sqft_built.value}
                onChange={onInputChange}
                onBlur={handleLocalBlur}
                placeholder="Enter..."
                error={
                  shouldShowError("client_sqft_built.value")
                    ? errors['client_sqft_built.value']
                    : undefined
                }
              />
            </div>

          </div>
        </div>
      </CardBorder>

      <div className="flex flex-col mt-8 pt-6">
        <CardBorder title="Tax Details" borderColor="border-[#2E4051]">
          <div className="flex w-full gap-4 items-center justify-center">
            <div className="flex w-full flex-wrap">
              <div className="flex w-full md:w-1/2 px-3 mb-6">
                <InputField
                  label="Client GSTIN"
                  name="gstn"
                  value={formData.gstn}
                  onChange={onInputChange}
                  onBlur={handleLocalBlur}
                  placeholder="Enter..."
                  error={
                    shouldShowError("gstn")
                      ? errors.gstn
                      : undefined
                  }
                />
              </div>

              <div className="flex w-full md:w-1/2 px-3 mb-6">
                <InputField
                  label="Client PAN"
                  name="pan"
                  value={formData.pan}
                  onChange={onInputChange}
                  onBlur={handleLocalBlur}
                  placeholder="Enter..."
                  error={
                    shouldShowError("pan")
                      ? errors.pan
                      : undefined
                  }
                />
              </div>

              <div className="flex w-full md:w-1/2 px-3 mb-6">
                <InputField
                  label="Client Invoice Value in INR"
                  name="invoice.value"
                  value={formData.invoice.value}
                  onChange={onInputChange}
                  onBlur={handleLocalBlur}
                  placeholder="Enter..."
                  error={
                    shouldShowError("invoice.value")
                      ? errors['invoice.value']
                      : undefined
                  }
                />
              </div>

              <div className="flex w-full md:w-1/2 px-3 mb-6">
                <InputField
                  label="Invoice collected to date in INR"
                  name="invoice_collected_to_date.value"
                  value={formData.invoice_collected_to_date.value}
                  onChange={onInputChange}
                  onBlur={handleLocalBlur}
                  placeholder="Enter..."
                  error={
                    shouldShowError("invoice_collected_to_date.value")
                      ? errors['invoice_collected_to_date.value']
                      : undefined
                  }
                />
              </div>

              <div className="flex w-full md:w-1/2 px-3 mb-6">
                <InputField
                  label="GST Collected in INR"
                  name="tax_collected_to_date.value"
                  value={formData.tax_collected_to_date.value}
                  onChange={onInputChange}
                  onBlur={handleLocalBlur}
                  placeholder="Enter..."
                  error={
                    shouldShowError("tax_collected_to_date.value")
                      ? errors['tax_collected_to_date.value']
                      : undefined
                  }
                />
              </div>
              <div className="flex w-full md:w-1/2 px-3 mb-6">
                <InputField
                  label="GST Paid in INR"
                  name="tax_paid_to_date.value"
                  value={formData.tax_paid_to_date.value}
                  onChange={onInputChange}
                  onBlur={handleLocalBlur}
                  placeholder="Enter..."
                  error={
                    shouldShowError("tax_paid_to_date.value")
                      ? errors['tax_paid_to_date.value']
                      : undefined
                  }
                />
              </div>
            </div>
          </div>
        </CardBorder>
      </div>
    </div>
  );
};

export default OperationalTax;
